.cards {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 2em;
}

.project-card {
  color: #9efff0;
  --color: #9efff0;
  --background: #292929;
  width: 360px;
  height: 290px;
  border-radius: 1rem;
}

.project-card img {
  width: 100%;
  height: 180px;
  object-fit: cover;
}
